export const tesEmployeesListingRoutes = [
  {
    path: 'listing',
    name: 'tes-employees-listing',
    component: () =>
      import(/* webpackChunkName: "tes-employees-listing" */ './TesEmployeesListing.vue')
  },
  {
    path: 'create',
    name: 'create-tes-employee',
    component: () =>
      import(/* webpackChunkName: "new-tes-employee" */ '../../../tes-employees/features/new-tes-employee/NewTesEmployee.vue')
  }
];
